export const COST_INPUT_CONFIG = {
  controlName: 'Cost',
  placeholder: 'Оголошена цінність',
  maxValue: 5000000,
  minValue: 0.1,
  allowFloat: true,
  digitsAfterDot: 2,
  maxInputLength: 7,
  initialValue: 200,
  unit: 'грн',
  debounceTime: 500,
  tooltipText:
    'Загальна оголошена вартість розраховується автоматично як сума оголошених вартостей усіх місць. Відшкодування здійснюється відповідно до оголошеної вартості, зазначеної для цього місця.',
};
